import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { HttpService } from '../http.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

export interface User {
  name: string;
}

@Component({
  selector: 'app-transaction-page',
  templateUrl: './transaction-page.component.html',
  styleUrls: ['./transaction-page.component.scss'],
})
export class TransactionPageComponent implements OnInit {
  myControl = new FormControl();
  options = [
    { siteName: 'Mary' },
    { siteName: 'Shelley' },
    { siteName: 'Igor' },
  ];
  filteredOptions: any;
  optionSelected = '';
  selectedId: any;
  bankName: string | null = '';
  virtualId: string | null = '';
  offerId: string | null = '';
  accessToken: any;
  date = new FormControl(new Date());
  selectedDate: string | Date = new Date();
  transactionForm = this.form.group({
    brand: new FormControl(null),
    orderId: new FormControl(),
    amount: new FormControl(),
    email: new FormControl(),
    mobile: new FormControl(),
    date: new FormControl(new Date()),
    description: new FormControl(),
  });
  keyword = 'siteName';

  async getTransaction() {
    this.filteredOptions = await this.httpService.getAllSites();
    console.log(this.filteredOptions);
  }

  constructor(
    public form: FormBuilder,
    public httpService: HttpService,
    public route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    var url = new URL(window.location.href);
    this.bankName = url.searchParams.get('bankName') || '';
    this.virtualId = url.searchParams.get('virtualId');
    this.offerId = url.searchParams.get('offerId');
    this.accessToken = url.searchParams.get('accessToken');
    console.log(' this.accessToken', this.accessToken);
    console.log(' this.bankName', this.bankName);
    console.log(' this.virtualId', this.virtualId);
    console.log(' this.offerId', this.offerId);
    localStorage.setItem('bName', this.bankName);
    localStorage.setItem('accessToken', this.accessToken);
    this.getTransaction();
  }

  async onSubmission() {
    console.log(this.transactionForm);
    let d: Date | null = null;
    if (this.transactionForm.value.date) {
      d = new Date(this.transactionForm.value.date);
      const date = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
      console.log(date);
    }
    if (this.validateForm()) {
      const model = {
        Id: 0,
        orderAmount: this.transactionForm.value.amount,
        siteId: this.selectedId ? this.selectedId : '1',
        transactionDate: this.selectedDate,
        description: this.transactionForm.value.description,
        emailId: this.transactionForm.value.email,
        mobileNo: this.transactionForm.value.mobile,
        orderId: this.transactionForm.value.orderId,
        BankName: this.bankName,
        BankUserId: this.virtualId,
        OfferId: this.offerId,
        //Chegcustomerid:this.chegcustomerid
      };
      let result = await this.httpService.postData(model);
      if (result == true) {
        this.toastr.success('Form submitted successfully.', 'Success');
      } else {
        this.toastr.warning('Failed to submit the form.', 'Warning');
      }
    } else {
      this.toastr.warning('One or more validation error occured.', 'Warning');
    }

    // this.resetForm();
  }

  selectEvent(item: any) {
    // do something with selected item
    console.log(item);
    this.selectedId = item.id;
  }

  onChangeSearch(search: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e: any) {
    // do something
  }
  resetForm() {
    this.transactionForm.setValue({
      brand: null,
      orderId: '',
      amount: '',
      email: '',
      mobile: '',
      date: null,
      description: '',
    });
  }
  eventStartDate(type: string, event: MatDatepickerInputEvent<Date>) {
    let sDate = this.transactionForm.value.date;
    console.log(sDate, 'sDaete');
    if (sDate && typeof sDate !== 'string') {
      this.selectedDate = sDate.toLocaleString();
    } else {
      this.selectedDate = '';
    }
    console.log('this', this.selectedDate);
  }
  validateForm() {
    let valid = true;
    if (
      this.transactionForm.value.amount == null ||
      this.transactionForm.value.amount == ''
    ) {
      valid = false;
      return valid;
    }
    if (
      this.transactionForm.value.description == null ||
      this.transactionForm.value.description == ''
    ) {
      valid = false;
      return valid;
    }
    if (
      this.transactionForm.value.email == null ||
      this.transactionForm.value.email == ''
    ) {
      valid = false;
      return valid;
    }
    if (
      this.transactionForm.value.mobile == null ||
      this.transactionForm.value.mobile == ''
    ) {
      valid = false;
      return valid;
    }
    return valid;
  }
}
